/**
 * App config — values come from CRA env files (REACT_APP_*).
 * See `.env.example`. Local overrides live in `.env.local` (gitignored).
 *
 * Note: anything REACT_APP_* is embedded in the browser bundle.
 * Never put real private keys here; use the backend for secrets.
 */

const trim = (value) => (typeof value === "string" ? value.trim() : "");

export const API_URL =
  trim(process.env.REACT_APP_API_URL) || "http://localhost:3333/api/v1";
